/* eslint-disable prettier/prettier */
import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { /* Link, */ Link as RouterLink } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Hidden from '@material-ui/core/Hidden';

import messages from 'aurora-translations';
import styles from './styles';

function BuyerSummary(props) {
  const {
    classes,
    switchType,
    property,
    expandedId,
    selectable,
    multi,
    selected,
    setSelected,
    buyerSelected,
    isExpired
  } = props;





  const isChecked = useMemo(() => {
    // For bulding, check for all units
    return multi && selected?.some(item => item.userId === property.userId);
  }, [property.propertyType, multi, selected]);


  const onItemClick = useCallback(
    async data => {

      if (selected?.userId === data.userId) {
        setSelected(null);
        return;
      }
      setSelected(data);
    },
    [multi, property, selected, expandedId],
  );

  return (
    <>
      <div className={classes.listItemContainer}>
        <ListItem
          className={classNames(classes.listItem, property?.userId !== buyerSelected?.userId && selected?.userId === property.userId && classes.selected)}
          dense
          button
          {...(selectable
            ? { onClick: () => onItemClick(property) }
            : {
              component: RouterLink,
              to: { pathname: `/app/properties/${property.userId}`, state: { type: switchType } },
            })}
        >
          <div className={classes.listMainContent}>
            {selectable &&
              (multi ? (
                <ListItemIcon className={classes.listItemIcon}>
                  <Checkbox
                    edge='start'
                    checked={isChecked || false}
                    indeterminate={false}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': property.userId }}
                    classes={{
                      root: classes.itemCheckbox,
                      checked: classes.itemCheckboxChecked,
                      indeterminate: classes.itemCheckboxIndeterminate,
                    }}
                  />
                </ListItemIcon>
              ) : (
                <ListItemIcon className={classes.listItemIcon}>
                  <Radio
                    edge='start'
                    checked={selected?.userId === property.userId || false}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': property.userId }}
                    classes={{ root: classes.itemCheckbox, checked: classes.itemCheckboxChecked }}
                  />
                </ListItemIcon>
              ))}
            <ListItemText
              id={property.userId}
              primary={
                <div
                  className={classNames(classes.listItemText, {
                  })}
                >
                  <div className={classNames(classes.item, classes.avatarItem)}>
                    <Avatar
                      className={classes.avatar}
                      variant='rounded'
                      src={property?.img}
                      alt='property-thumbnail'
                    />
                    <div>
                      <Typography className={classes.title}>{property?.nameEN}</Typography>
                      <Typography className={classes.title}>{property?.nameAR}</Typography>
                    </div>
                  </div>
                  <div className={classNames(classes.item, classes.Localityitem)}>
                    <Hidden mdUp>
                      <div className={classes.item}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"> <g> <path fill="none" d="M0 0h24v24H0z" /> <path stroke="#8c9099" fillRule="nonzero" d="M20 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16zm-1 2H5v16h14V4zm-3 12v2H8v-2h8zM12 6a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" /> </g> </svg>
                        <Typography>
                          {property?.passportNumber}
                        </Typography>
                      </div>

                      <div className={classes.item}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" className="bi bi-flag" viewBox="0 0 16 16"> <path stroke="#8c9099" d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z" /> </svg>
                        <Typography>
                          {property?.nationality}
                        </Typography>
                      </div>

                      <div className={classes.item}>
                        <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 24V9H24H4V24V39H24" stroke="#130F26" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" /><path d="M31 36L36 40L44 30" stroke="#130F26" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" /><path d="M4 9L24 24L44 9" stroke="#130F26" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        <Typography>
                          {property?.email}
                        </Typography>
                      </div>

                      <div className={classes.item}>
                        <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none" /><rect x="24" y="64" width="208" height="128" rx="16" transform="translate(256) rotate(90)" fill="none" stroke="#8c9099" strokeLinecap="round" strokeLinejoin="round" strokeWidth="8" /><circle cx="128" cy="60" r="8" /></svg>
                        <Typography>
                          {property?.mobileNumber}
                        </Typography>
                      </div>
                    </Hidden>
                    <Typography className={classes.subTitle}>
                      <FormattedMessage {...messages.Passport_number} />
                    </Typography>
                    <Hidden smDown>
                      <Typography>{property?.passportNumber}</Typography>
                    </Hidden>
                  </div>
                  <Hidden smDown>
                    <div className={classes.item}>
                      <Typography className={classes.subTitle}>
                        <FormattedMessage {...messages.Nationality} />
                      </Typography>
                      <Typography>{property?.nationality}</Typography>
                    </div>
                    <div className={classes.item}>
                      <Typography className={classes.subTitle}>
                        <FormattedMessage {...messages.Email} />
                      </Typography>
                      <Typography>{property?.email}</Typography>
                    </div>
                    <div className={classes.item}>
                      <Typography className={classes.subTitle}>
                        <FormattedMessage {...messages.mobile} />
                      </Typography>
                      <Typography>{property?.mobileNumber}</Typography>
                    </div>
                  </Hidden>
                </div>
              }
            />
          </div>
          {buyerSelected?.userId === selected?.userId && (
            <>
              {property?.userId === buyerSelected?.userId && isExpired &&
                <div className={classes.errorMsg}>
                  <span className='icon'>
                    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M7.74342 1.95361C8.89812 -0.0463877 11.7849 -0.0463857 12.9396 1.95361L19.9485 14.0934C21.1032 16.0934 19.6598 18.5934 17.3504 18.5934H3.3326C1.0232 18.5934 -0.420176 16.0934 0.734525 14.0934L7.74342 1.95361ZM10.188 15.6918C10.8663 15.6918 11.4162 15.142 11.4162 14.4637C11.4162 13.7854 10.8663 13.2355 10.188 13.2355C9.50972 13.2355 8.95985 13.7854 8.95985 14.4637C8.95985 15.142 9.50972 15.6918 10.188 15.6918ZM8.95981 5.86653C8.95981 5.19104 9.51249 4.63837 10.188 4.63837C10.8635 4.63837 11.4161 5.19104 11.4161 5.86653V10.7792C11.4161 11.4547 10.8635 12.0073 10.188 12.0073C9.51249 12.0073 8.95981 11.4547 8.95981 10.7792V5.86653Z" fill="#E95635" />
                    </svg>
                  </span>
                  <span>
                    <FormattedMessage {...messages.buyer_expired_passport} />  {" "}
                    <a target='_blank' href='https://www.adgm.com/contact-us/make-enquiry' rel='noreferrer'>
                      <FormattedMessage {...messages.need_help_contact_us} />
                    </a>
                  </span>
                </div>
              }
            </>
          )}
        </ListItem>
     
      </div>
    </>
  );
}

BuyerSummary.propTypes = {
  classes: PropTypes.object.isRequired,
  buyerSelected: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  switchType: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  expandedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isExpired: PropTypes.bool,
  selectable: PropTypes.bool.isRequired,
  multi: PropTypes.bool.isRequired,
  selected: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  setSelected: PropTypes.func.isRequired,
};

BuyerSummary.defaultProps = {
  expandedId: null,
  selected: null,
  isExpired: false,
};

export default withStyles(styles)(memo(BuyerSummary));
